/**
 * Sorts filter options by result count in descending order.
 * Used to ensure apps are ranked properly by their result counts.
 */
export const sortByResultCount = <T extends { count?: number }>(apps: T[]): T[] => {
	return apps.sort((a, b) => {
		const countA = a.count ?? 0;
		const countB = b.count ?? 0;
		return countB - countA;
	});
};
